import axios from 'axios'
import store from '@state/store'

const http = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: { 'Content-Type': 'application/json' },
})

export default http
